// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popup-parent--hidden .fixed-header {\n  padding-right: 15px;\n}\n", ""]);
// Exports
exports.locals = {
	"sideBarWidth": "210px",
	"appHeaderHeight": "60px",
	"interval": "16px"
};
module.exports = exports;
